import { CmsObjectWithDefault } from '@components/Cms/types';

export type MemberSignoutLinkCmsKey = 'notThisUser' | 'signOut';

export const MemberSignoutLinkCmsWithDefault: CmsObjectWithDefault<MemberSignoutLinkCmsKey> = {
    notThisUser: {
        cmsId: 67380,
        defaultTranslation: 'Not {1}?',
    },
    signOut: {
        cmsId: 67381,
        defaultTranslation: 'Sign out',
    },
};
